import { getIcon, getSoulIcon } from "../assets/icons.js";
import { elementFactory } from "./factory.js";
import { ELEMENT_COLORS_HSL } from "../assets/elements.js";
import { spellbookSubmenu } from "./spellbookSubmenu.js";
import { settingsSubmenu } from "./settingsSubmenu.js";

export class playerMenu {

    constructor(containerEl, gameState, uiManager) {
        this.gameState = gameState;
        this.container = containerEl;
        this.uiManager = uiManager;

        this.settingsContainer = this.container.querySelector('.submenu-settings');
        this.awakeningContainer = this.container.querySelector('.submenu-awakening');
        this.cultivationContainer = this.container.querySelector('.submenu-cultivation');
        this.formationContainer = this.container.querySelector('.submenu-formation');
        this.spellbookContainer = this.container.querySelector('.submenu-spellbook');

        this.settingsSubmenu = new settingsSubmenu(this.settingsContainer, this.uiManager);

        this.spellbookSubmenu = new spellbookSubmenu(this.spellbookContainer, this.gameState);

        this.awakeningSubmenu = {
            currentMp: this.awakeningContainer.querySelector('#awaken-current-mp'),
            targetMp: this.awakeningContainer.querySelector('#awaken-target-mp'),
            progressFill: this.awakeningContainer.querySelector('#awaken-progress-fill'),
            timerDisplay: this.awakeningContainer.querySelector('#awaken-timer'),
            awakenButton: this.awakeningContainer.querySelector('#awaken-action-btn')
        }


        this.cultivationSubmenu = {
            dustDisplay: this.cultivationContainer.querySelector('.dust-display'),
            dustCount: this.cultivationContainer.querySelector('#dust-count'),
            dropdown: {
                container: this.cultivationContainer.querySelector('.cultivation-dropdown-container'),
                header: this.cultivationContainer.querySelector('.cultivation-dropdown-header'),
                title: this.cultivationContainer.querySelector('.cultivation-dropdown-title'),
                options: this.cultivationContainer.querySelector('.cultivation-dropdown-options'),
                optionButtons: null
            },
            progressSquare: {
                container: this.cultivationContainer.querySelector('.progress-square-containe'),
                progressFill: this.cultivationContainer.querySelector('.progress-square'),
            },
            soulSlots: Array.from(this.cultivationContainer.querySelectorAll('.soul-slot')),
            cultivateButton: this.cultivationContainer.querySelector('#cultivate-btn'),
            cultivationCostDisplay: this.cultivationContainer.querySelector('.cultivation-mp-cost-display')

        }

        this.formationSubmenu = {
            elementTabs: this.formationContainer.querySelector('.formation-element-tabs'),
            elementButtons: null,

            info: {
                container: this.formationContainer.querySelector('.formation-info-container'),
                tierCount: this.formationContainer.querySelector('#tier-count'),
                dustCount: this.formationContainer.querySelector('#formation-dust-count'),
                formationCount: this.formationContainer.querySelector('#formation-count')
            },

            display: {
                container: this.formationContainer.querySelector('.formation-display-container'),
                canvas: this.formationContainer.querySelector('.formation-display-container canvas')
            },

            actions: {
                row: this.formationContainer.querySelector('.formation-actions-row'),
                createAmountBtn: this.formationContainer.querySelector('.formation-create-amount-button'),
                createBtn: this.formationContainer.querySelector('.formation-create-button'),
                formBtn: this.formationContainer.querySelector('.formation-form-button')
            },

            starCostDisplay: this.formationContainer.querySelector('.star-cost-display')
        }

        this.currentAwakeningColor = "#e0e0e0";

        this.currentCultivationColor = "#e0e0e0";

        this.updateState = {
            updateAwakeningProgress: false,
            updateCurrentAwakeningColor: false,
            updateCultivationProgress: false
        }


    }


    setupPlayerSubmenus() {
        this.setupAwakeningSubmenu();
        this.setupCultivationSubmenu();
        this.setupFormationSubmenu();

        this.spellbookSubmenu.init();
        this.settingsSubmenu.init();
    }

    updateUI(uiState) {
        if (uiState.activePlayerSubmenu === "awakening") {
            if (this.gameState.actions.awakening.isActive) {
                if (!this.updateState.updateAwakeningProgress) {
                    this.updateState.updateAwakeningProgress = true;
                    this.currentAwakeningColor = ELEMENT_COLORS_HSL[this.gameState.actions.awakening.targetElement].color
                }
                this.updateAwakenProgress(
                    this.gameState.calculateActionProgressPercentage("awakening"),
                    this.gameState.actions.awakening.isActive,
                    this.gameState.actions.awakening.progress,
                    this.gameState.actions.awakening.duration);

            } else if (this.updateState.updateAwakeningProgress) {
                this.updateState.updateAwakeningProgress = false;
                this.updateAwakenProgress(
                    this.gameState.calculateActionProgressPercentage("awakening"),
                    this.gameState.actions.awakening.isActive,
                    this.gameState.actions.awakening.progress,
                    this.gameState.actions.awakening.duration);

                this.currentAwakeningColor = "#e0e0e0";
            }

        } else if (uiState.activePlayerSubmenu === "formation") {
            if (this.gameState.uiInfo.newElement.formation) {
                this.generateFormationElementButtons();
                this.gameState.uiInfo.newElement.formation = false;
            }

            if (this.gameState.uiInfo.formationUpdate) {
                this.updateFormationUI(this.gameState.uiInfo.currentFormationMenu);
                this.gameState.uiInfo.formationUpdate = false;
            }



        } else if (uiState.activePlayerSubmenu === "cultivation") {
            if (this.gameState.uiInfo.newElement.cultivation) {
                this.generateCultivationDropdownButtons();
                this.gameState.uiInfo.newElement.cultivation = false;
            }
            if (this.gameState.uiInfo.currentCultivationMenu !== "none") {
                const currentAction = this.gameState.actions.cultivation[this.gameState.uiInfo.currentCultivationMenu];
                if (currentAction.isActive) {
                    this.updateCultivationProgress();

                    this.updateState.updateCultivationProgress = true;
                }
                else if (this.updateState.updateCultivationProgress) {
                    this.updateCultivationProgress();

                    this.updateState.updateCultivationProgress = false;
                }
            }
            if (this.gameState.uiInfo.dustUpdate) {
                this.updateCultivationText();
                this.updateCultivationSoulDisplay();

                this.gameState.uiInfo.dustUpdate = false;
            } if (this.gameState.uiInfo.soulUpdate) {
                this.updateCultivationSoulDisplay();

                this.gameState.uiInfo.soulUpdate = false;
            }

        } else if (uiState.activePlayerSubmenu === "spellbook") {
            this.spellbookSubmenu.update();
        } else if (uiState.activePlayerSubmenu === "settings") {

        }

    }

    //Formation Submenu
    setupFormationSubmenu() {
        this.formationSubmenu.actions.createAmountBtn.addEventListener("click", (e) => { this.toggleStarCreationAmount() });
        this.generateFormationElementButtons();

        // this.formationSubmenu.actions.formBtn.addEventListener("click", (e) => {this.handleFormButtonClick()});

        // Event listener for selecting an element from the formation element buttons
        this.formationSubmenu.elementTabs.addEventListener('click', (event) => {
            const clickedButton = event.target.closest('.formation-element-button');
            if (!clickedButton) return;

            const chosenElement = clickedButton.dataset.element;
            if (chosenElement !== 'none') {
                this.selectElementForFormation(chosenElement);
                this.updateFormationUI(chosenElement);
            } else {
                console.log("Error: trying to set formation menu to no element");
            }
        });


        // //Setting default element on load
        // const unlockedElements = Object.keys(this.gameState.player.elements);
        // if (unlockedElements.length > 0) {
        //     const defaultElement = unlockedElements[0]; 
        //     this.selectElementForFormation(defaultElement);
        //     this.updateFormationUI(defaultElement); // Correctly activates the first tab on load
        // } else {
        //     this.gameState.uiInfo.currentFormationMenu = "none";
        //     this.gameState.player.currentFormationElement = null;
        //     this.updateFormationStatDisplay();
        // }

        this.formationSubmenu.actions.formBtn.addEventListener("click", (e) => { this.handleFormButtonClick() });
        this.formationSubmenu.actions.createBtn.addEventListener("click", (e) => { this.handleCreateButtonClick() });
    }

    generateFormationElementButtons() {
        const buttonContainer = this.formationSubmenu.elementTabs;
        buttonContainer.innerHTML = '';

        this.formationSubmenu.elementButtons = elementFactory.createFormationElementButtons(this.gameState.player.elements);

        buttonContainer.append(...this.formationSubmenu.elementButtons);
    }


    selectElementForFormation(elementName) {
        this.gameState.player.currentFormationElement = elementName;
        this.gameState.uiInfo.currentFormationMenu = elementName;

        this.gameState.uiInfo.starCreationAmount = 'reset';
        this.toggleStarCreationAmount();
    }

    updateFormationUI(element) {
        this.updateFormationStatDisplay();

        this.updateStarCostDisplay();

        if (this.formationSubmenu.elementButtons) {
            this.formationSubmenu.elementButtons.forEach(btn => {
                if (btn.dataset.element === element) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });
        }
    }

    updateFormationStatDisplay() {
        let currentElement = this.gameState.player.currentFormationElement;
        if (this.gameState.player.elements[currentElement]) {

            this.formationSubmenu.info.formationCount.innerText = JSON.stringify(this.gameState.player.elements[currentElement]);



            let dustCount = this.gameState.getElementDustString(currentElement);


            this.formationSubmenu.info.dustCount.innerText = dustCount;

            let tierString = this.gameState.getCurrentTier(currentElement);
            this.formationSubmenu.info.tierCount.innerText = tierString;

            this.gameState.uiInfo.dustUpdate = true;
            this.updateCultivationText();
        }
    }

    toggleStarCreationAmount() {
        let currentElement = this.gameState.player.currentFormationElement;
        if (!this.gameState.player.elements[currentElement]) return;

        if (this.gameState.uiInfo.starCreationAmount === 1) {
            this.gameState.uiInfo.starCreationAmount = 'max';
        } else {
            this.gameState.uiInfo.starCreationAmount = 1;
        }

        this.updateStarCostDisplay();
    }

    updateStarCostDisplay() {
        let currentElement = this.gameState.player.currentFormationElement;
        if (!this.gameState.player.elements[currentElement]) return;

        if (this.gameState.uiInfo.starCreationAmount === 'max') {
            const purchaseInfo = this.gameState.getMaxStarsPurchasable(currentElement);
            this.formationSubmenu.actions.createAmountBtn.innerText = "MAX";
            this.formationSubmenu.starCostDisplay.innerText = `Create ${purchaseInfo.maxStars} stars for: ${purchaseInfo.cost.toFixed(0)} Dust`;
        } else {
            const dustCost = this.gameState.getStarCost(currentElement);
            this.formationSubmenu.actions.createAmountBtn.innerText = "1x";
            this.formationSubmenu.starCostDisplay.innerText = `Create 1 star for: ${dustCost.toFixed(0)} Dust`;
        }
    }



    handleCreateButtonClick() {
        this.gameState.createStars(this.gameState.uiInfo.starCreationAmount);
    }

    handleFormButtonClick() {
        this.gameState.upgradeFormations();
    }

    updateFormationCanvas() {
        //TODO:
        //call to formationCanvas.js logic
    }




    //Cultivation Submenu
    setupCultivationSubmenu() {
        //Event listener for opening the dropdown
        this.cultivationSubmenu.dropdown.header.addEventListener("click", (e) => {
            const options = this.cultivationSubmenu.dropdown.options;
            options.style.display = options.style.display === 'flex' ? 'none' : 'flex';
        });

        //Event listener for closing dropdown when clicking outside its bounds
        window.addEventListener("click", (e) => {
            const button = this.cultivationSubmenu.dropdown.header;
            const options = this.cultivationSubmenu.dropdown.options;

            if (!button.contains(e.target) && !options.contains(e.target)) {
                options.style.display = 'none';
            }
        });

        //Event listeners for selecting an element in cultivation menu
        this.cultivationSubmenu.dropdown.options.addEventListener('click', (event) => {
            const clickedButton = event.target.closest('.cultivation-drop-button');
            if (!clickedButton) return;
            const chosenElement = clickedButton.dataset.element;

            if (chosenElement !== 'none') {
                this.selectElementForCultivation(chosenElement);
                this.updateCultivation(chosenElement);
                this.cultivationSubmenu.dropdown.options.style.display = 'none';
            } else {
                console.log("Error: trying to set cultivation menu to no element");
            }
        });


        const unlockedElements = Object.keys(this.gameState.player.elements);

        if (unlockedElements.length > 0) {
            const defaultElement = unlockedElements[0];
            this.selectElementForCultivation(defaultElement);
            this.updateCultivation(defaultElement);
        } else {
            this.gameState.uiInfo.currentCultivationMenu = "none";
            this.gameState.player.currentCultivationElement = null;
            this.cultivationSubmenu.dropdown.title.innerText = "SELECT AN ELEMENT...";
        }


        this.generateCultivationDropdownButtons();

        // Event listeners for selecting an element in cultivation menu
        this.cultivationSubmenu.dropdown.options.addEventListener('click', (event) => {
            const clickedButton = event.target.closest('.cultivation-drop-button');
            if (!clickedButton) return;
            const chosenElement = clickedButton.dataset.element;

            if (chosenElement !== 'none') {
                // PERSISTENCE: Save the chosen element to the player's state
                this.gameState.player.currentCultivationElement = chosenElement;

                this.selectedSoulTier = null;

                this.selectElementForCultivation(chosenElement);
                this.updateCultivation(chosenElement);
                this.cultivationSubmenu.dropdown.options.style.display = 'none';
            } else {
                console.log("Error: trying to set cultivation menu to no element");
            }
        });

        this.cultivationSubmenu.cultivateButton.addEventListener('click', () => {
            this.handleCultivationButtonClick();
        });

        //Soul Slot Click Listeners (Selection)
        this.cultivationSubmenu.soulSlots.forEach((slot, index) => {
            const tier = index + 1; // Array indices 0-5 map to Tiers 1-6

            slot.style.cursor = "pointer";

            slot.addEventListener('click', () => {
                if (this.selectedSoulTier === tier) {
                    this.selectedSoulTier = null;
                } else {
                    this.selectedSoulTier = tier;
                }
                this.updateCultivationSoulDisplay();
            });
        });

        //Persistence

        // Try to load the previously saved element, otherwise fallback to the first unlocked one
        let elementToLoad = this.gameState.player.currentCultivationElement;
        if (!elementToLoad || !unlockedElements.includes(elementToLoad)) {
            elementToLoad = unlockedElements.length > 0 ? unlockedElements[0] : null;
        }

        if (elementToLoad) {
            // Ensure the state matches what we're loading
            this.gameState.player.currentCultivationElement = elementToLoad;

            this.selectElementForCultivation(elementToLoad);
            this.updateCultivation(elementToLoad);
        } else {
            this.gameState.uiInfo.currentCultivationMenu = "none";
            this.gameState.player.currentCultivationElement = null;
            this.cultivationSubmenu.dropdown.title.innerText = "SELECT AN ELEMENT...";
        }

    }

    generateCultivationDropdownButtons() {
        const dropdownContainer = this.cultivationSubmenu.dropdown.options;
        dropdownContainer.innerHTML = '';

        this.cultivationSubmenu.dropdown.optionButtons = elementFactory.createCultivationDropButtons(this.gameState.player.elements);

        dropdownContainer.append(...this.cultivationSubmenu.dropdown.optionButtons);
    }

    updateCultivation(element) {
        const elementColorConfig = (element && ELEMENT_COLORS_HSL[element]);
        const color = elementColorConfig ? elementColorConfig.color : null;

        this.currentCultivationColor = color;

        if (color) {
            this.cultivationSubmenu.dustDisplay.style.color = this.currentCultivationColor;
            this.cultivationSubmenu.cultivateButton.style.backgroundColor = this.currentCultivationColor;
        } else {
            this.cultivationSubmenu.dustDisplay.style.color = "#e0e0e0";
            this.cultivationSubmenu.cultivateButton.style.backgroundColor = "#e0e0e0";
            console.log("Error: No valid element selected or color missing");
        }

        this.updateCultivationText();
        this.updateCultivationSoulDisplay();
        this.updateCultivationProgress();
    }

    updateCultivationText() {
        this.gameState.uiInfo.dustUpdate = true;
        const currentViewedElement = this.gameState.uiInfo.currentCultivationMenu;

        if (this.gameState.uiInfo.dustUpdate && currentViewedElement !== "none") {
            if (this.gameState.player.elements[currentViewedElement]) {
                const dustText = this.gameState.getElementDustString(currentViewedElement);
                this.cultivationSubmenu.dustCount.innerText = dustText;
            }
            this.gameState.uiInfo.dustUpdate = false;
        }

        this.cultivationSubmenu.cultivationCostDisplay.innerText = `Cost: ${0} MP`;
    }

    updateCultivationSoulDisplay() {
        const currentElement = this.gameState.player.currentCultivationElement;

        if (!currentElement || currentElement === "none") {
            this.cultivationSubmenu.soulSlots.forEach(slot => {
                slot.innerHTML = '';
            });
            return;
        }

        const tiers = this.gameState.soulHandler.tiers //[1, 2, 3, 4, 5, 6];

        tiers.forEach((tier, index) => {
            const slot = this.cultivationSubmenu.soulSlots[index];
            if (!slot) return;

            const amount = this.gameState.soulHandler.getSouls(currentElement, tier) || 0;
            const svgIcon = getSoulIcon(currentElement, tier);

            slot.style.position = "relative";
            slot.style.opacity = amount > 0 ? "1" : "0.4";
            slot.style.filter = amount > 0 ? "none" : "grayscale(80%)";

            // VISUAL SELECTION: Check if this tier is the currently selected one
            if (this.selectedSoulTier === tier) {
                slot.style.border = "2px solid #ffffff";
                slot.style.zIndex = "2";
            } else {
                slot.style.border = "2px solid transparent"; // Invisible border to prevent layout jumping
                slot.style.boxShadow = "none";
                slot.style.zIndex = "1";
            }

            slot.innerHTML = `
                <div class="soul-icon" style="width: 100%; height: 100%;">
                    ${svgIcon}
                </div>
                <div class="soul-amount-text" style="
                    position: absolute; 
                    bottom: 2px; 
                    right: 4px; 
                    color: white; 
                    font-size: 0.9em; 
                  ">
                    x${amount}
                </div>
            `;
        });
    }

    handleCultivationButtonClick() {
        const elementName = this.gameState.player.currentCultivationElement;
        
        if (!elementName || elementName === "none") return;

        const soulTier = this.selectedSoulTier || 0; 

        const mpUsed = 1; 

        this.gameState.startCultivation(elementName, soulTier, mpUsed);

        this.updateCultivationSoulDisplay();
        this.updateCultivationText();
    }

    selectElementForCultivation(elementName) {
        const uppercaseName = elementName.toUpperCase();
        this.cultivationSubmenu.dropdown.title.innerText = `${uppercaseName}`;
        this.gameState.player.currentCultivationElement = elementName;
        this.gameState.uiInfo.currentCultivationMenu = elementName;
    }

    updateCultivationProgress() {
        let percent = this.gameState.getCurrentCultivationProgressPercentage() || 0;
        const fillHex = this.currentCultivationColor || "#444";
        const gradientString = `conic-gradient(${fillHex} 0% ${percent}%, #111 ${percent}% 100%)`;
        this.cultivationSubmenu.progressSquare.progressFill.style.background = gradientString;
    }


    //Awakening Submenu
    setupAwakeningSubmenu() {
        this.awakeningSubmenu.awakenButton.addEventListener('click', () => {
            this.gameState.startAwakening(Date.now());
        });
    }

    setAwakenRequirementState(isFulfilled) {
        const btn = document.getElementById('awaken-action-btn');
        btn.disabled = !isFulfilled;
    }

    updateAwakenProgress(percent, isRunning, progress, duration) {
        let secondsRemaining = Math.floor((duration - progress) / 1000);

        this.awakeningSubmenu.progressFill.style.backgroundColor = this.currentAwakeningColor;
        this.awakeningSubmenu.progressFill.style.width = `${percent}%`;
        this.awakeningSubmenu.progressFill.style.height = `${percent}%`;


        if (isRunning) {
            this.awakeningSubmenu.timerDisplay.classList.remove('hidden');

            //Format time string 
            const mins = String(Math.floor(secondsRemaining / 60)).padStart(2, '0');
            const secs = String(secondsRemaining % 60).padStart(2, '0');
            this.awakeningSubmenu.timerDisplay.innerText = `Time Remaining: ${mins}:${secs}`;
        } else {
            this.awakeningSubmenu.timerDisplay.classList.add('hidden');
        }
    }

}